import { PendingPosition } from '@flipster/r230522/original/order';
import { numberFormatter } from '@flipster/utils/num';

import { IPositionLineAdapter } from '../../../../../lib/charting_library/charting_library';
import { ChartStyles } from '../../../../misc/constants';
import TradingView from '../../../../trading-view';

const OrderLineMapper = {
  Long: {
    bodyColor: ChartStyles.Color.TriggerLong,
    lineColor: ChartStyles.Color.Up,
  },
  Short: {
    bodyColor: ChartStyles.Color.TriggerShort,
    lineColor: ChartStyles.Color.Down,
  },
};

class OrderLineHelper {
  #lines: Record<string, IPositionLineAdapter> = {};

  constructor(
    private readonly tv: TradingView,
    private readonly label: string,
    private readonly getValue: (order: PendingPosition) => number,
  ) {}

  draw(symbol: string, orders: PendingPosition[]) {
    if (this.tv.symbol !== symbol) return;
    // 기존 라인중 사라진것 삭제
    Object.keys(this.#lines).forEach((id) => {
      if (!orders.find((p) => p.orderId === id)) this.#remove(id);
    });
    // 라인 업데이트
    [...orders]
      .sort((a, b) => a.slot - b.slot)
      // slot 순서를 보장해서 오는게 아니라 그대로 그리면 오는 순서대로 위에 덮협니다. 비슷한 위치의 겹치는 라인의 경우 UI적 일관성이 깨져서 일관된 UI를 보여주기 위함입니다
      .forEach((o) => this.#draw(o));
  }

  #draw(order: PendingPosition) {
    try {
      if (!this.tv.enabled || !this.tv.activeChart) return;
      const lineInfo = OrderLineMapper[order.side];
      this.#lines[order.orderId] ??= this.tv
        .createPositionLine()
        .setLineColor(lineInfo.lineColor)
        .setBodyTextColor(ChartStyles.Color.White)
        .setBodyBackgroundColor(lineInfo.bodyColor)
        .setBodyBorderColor(lineInfo.bodyColor)
        .setQuantityTextColor(ChartStyles.Color.White)
        .setQuantityBackgroundColor(ChartStyles.Color.Background)
        .setQuantityBorderColor(lineInfo.bodyColor);
      this.#lines[order.orderId]
        .setText(this.label + ' ' + numberFormatter(order.qty))
        .setPrice(this.getValue(order))
        .setQuantity('');
    } catch {
      // Value is null error
    }
  }

  #remove(id: string) {
    this.#lines[id]?.remove();
    delete this.#lines[id];
  }

  clean() {
    Object.keys(this.#lines).forEach((id) => {
      this.#remove(id);
    });
  }
}

export default OrderLineHelper;
